<template>
  <section class="magazine-section">
    <div class="container">
      <div class="section-header">
        <h2 class="title">물개 매거진</h2>
        <p class="sub-title">부동산 트렌드와 꿀팁, 인스타그램에서 만나보세요</p>
      </div>

      <div v-if="isLoading" class="loading-state">로딩중...</div>

      <div v-else-if="magazineItems.length === 0" class="empty-state">
        등록된 매거진이 없습니다.
      </div>

      <div v-else class="magazine-grid">
        <a
          v-for="item in magazineItems"
          :key="item.id"
          :href="item.linkUrl"
          class="magazine-card"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div class="thumb-wrapper">
            <img :src="item.imageUrl" :alt="item.title">
            <div class="hover-overlay">
              <span class="view-text">Instagram에서 보기</span>
            </div>
          </div>

          <div class="card-info">
            <h3 class="card-title">{{ item.title }}</h3>
            <span class="date">{{ item.date }}</span>
          </div>
        </a>
      </div>

      <div class="bottom-action">
        <a href="https://instagram.com/moolgae_official" target="_blank" rel="noopener noreferrer" class="view-all-btn">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="insta-icon">
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
            <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
          </svg>
          @moolgae_official 팔로우하기
          <svg class="arrow-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 5l7 7-7 7"/>
          </svg>
        </a>
      </div>

    </div>
  </section>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useMagazine } from '@/composables/main/useMagazine'

export default {
  name: 'MagazineSection',
  setup() {
    const { getActiveMagazines } = useMagazine()
    const magazineItems = ref([])
    const isLoading = ref(true)

    onMounted(async () => {
      magazineItems.value = await getActiveMagazines()
      isLoading.value = false
    })

    return { magazineItems, isLoading }
  }
}
</script>

<style scoped>
.magazine-section {
  padding: 80px 0;
  background-color: #ffffff;
}

.container {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Header */
.section-header {
  margin-bottom: 40px;
  text-align: left;
}

.title {
  font-size: 32px;
  font-weight: 800;
  color: #1e293b;
  letter-spacing: -0.03em;
  margin-bottom: 8px;
}

.sub-title {
  font-size: 16px;
  color: #64748b;
  font-weight: 500;
}

/* Loading & Empty */
.loading-state, .empty-state {
  text-align: center;
  padding: 60px 0;
  color: #94a3b8;
}

/* Grid Layout */
.magazine-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-bottom: 40px;
}

/* Card Design */
.magazine-card {
  display: flex;
  flex-direction: column;
  text-decoration: none;
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid transparent;
  transition: all 0.3s ease;
  padding: 12px;
  background: #fff;
}

.magazine-card:hover {
  box-shadow: 0 12px 30px -4px rgba(37, 99, 235, 0.15);
  border-color: rgba(37, 99, 235, 0.3);
  transform: translateY(-4px);
}

/* 4:5 Thumbnail Area */
.thumb-wrapper {
  width: 100%;
  aspect-ratio: 4 / 5;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  background: #F3F4F6;
}

.thumb-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.magazine-card:hover .thumb-wrapper img {
  transform: scale(1.05);
}

/* Hover Overlay */
.hover-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.magazine-card:hover .hover-overlay {
  opacity: 1;
}

.view-text {
  color: white;
  font-weight: 600;
  font-size: 13px;
  padding: 8px 16px;
  border: 1px solid rgba(255,255,255,0.6);
  border-radius: 100px;
  backdrop-filter: blur(4px);
}

/* Text Info */
.card-info {
  margin-top: 16px;
  padding: 0 4px;
}

.card-title {
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.4;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  transition: color 0.2s;
}

.magazine-card:hover .card-title {
  color: #2563eb;
}

.date {
  font-size: 13px;
  color: #64748b;
}

/* Bottom Action */
.bottom-action {
  text-align: center;
}

.view-all-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #64748b;
  text-decoration: none;
  padding: 12px 24px;
  border-radius: 12px;
  transition: all 0.2s;
}

.view-all-btn:hover {
  background: #f3f4f6;
  color: #1e293b;
}

.insta-icon {
  color: #E1306C;
}

/* Responsive */
@media (max-width: 960px) {
  .magazine-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .magazine-section {
    padding: 50px 0;
  }

  .title {
    font-size: 32px;
  }

  .magazine-grid {
    display: flex;
    overflow-x: auto;
    gap: 16px;
    margin: 0 -24px 32px -24px;
    padding: 0 24px 20px 24px;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .magazine-grid::-webkit-scrollbar {
    display: none;
  }

  .magazine-card {
    flex: 0 0 200px;
  }
}
</style>
